




















import mixins from 'vue-typed-mixins';
import JQueryMixin from '../../mixins/SmartTable/JQueryMixin';
import RandomMixin from '../../mixins/SmartTable/RandomMixin';

export default mixins(JQueryMixin, RandomMixin).extend({
  props: {
    dialogId: { type: String, default: 'smartTableAddDialog' },
    title: String
  },
  data: function () {
    return {
      localIdentifier: 0
    };
  },
  created: function () {
    this.localIdentifier = this.getRandom();
  },
  computed: {
    realDialogIdentifier: function (): string {
      return this.dialogId === 'smartTableAddDialog'
        ? `${this.dialogId}-${this.localIdentifier}`
        : this.dialogId;
    }
  },
  methods: {
    show: function () {
      this.jquery()('#' + this.realDialogIdentifier).modal('show');
    },
    hide: function () {
      this.jquery()('#' + this.realDialogIdentifier).modal('hide');
    }
  }
});
